import { useEffect, useState } from "react";
import { IoEyeSharp } from "react-icons/io5";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import QuotesFiles from "./QuotesFiles.jsx";
import Select from "react-select";
import { FaStarOfLife } from "react-icons/fa";
import { notify, Toast } from "../../common/Toast/index.js";
import Loader from "../../common/Loader/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const ActiveDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(8);
  const navigate = useNavigate();
  const { quotationNo } = useParams();
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const { activeDetailsData } = location.state || {};
  const [quotationDetails, setQuotationDetails] = useState({
    quotationNo: 0,
    quotationDate: today,
    siteId: "",
    totalSqFt: "",
    remark: "",
    salePersonId: "",
    stageId: null,
    finalAmount: "",
    finalProfileColor: "",
    glassColorType: "",
    workCompleteDate: "",
    reason: "",
    quote_Amount: "",
  });

  const [files, setFiles] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isSiteDetailsData, setIsSiteDetailsData] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [salesPersons, setSalesPersons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [displayNames, setDisplayNames] = useState({
    ownerName: "-",
    architectName: "-",
    fabricatorName: "-",
  });
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const { selectedSite } = location.state || {};

  useEffect(() => {
    fetchSiteDetails();

    if (selectedSite) {
      setQuotationDetails((prev) => ({
        ...prev,
        siteId: selectedSite.site_Id?.toString(),
      }));

      fetchDealDetails(selectedSite.site_Id);
    }
  }, []);

  const shouldShowCloseWonFields = (stageId) => {
    return [2, 6, 7].includes(stageId);
  };
  const isCloseWonEditable = (stageId) => {
    return stageId === 2;
  };

  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };

  useEffect(() => {
    if (quotationNo) {
      fetchQuotationDetails();
    }
  }, [quotationNo]);

  useEffect(() => {
    fetchSiteDetails();
    fetchSalePersons();
  }, []);

  useEffect(() => {
    if (siteDetails) {
      updateDisplayNames();
    }
  }, [siteDetails]);

  const validateForm = () => {
    const newErrors = {};
    if (!quotationDetails.quotationDate) {
      newErrors.quotationDate = "Quotation Date is required";
    }
    if (!quotationDetails.totalSqFt) {
      newErrors.totalSqFt = "Total_SqFt is required";
    }
    if (!quotationDetails.siteId) {
      newErrors.siteId = "Site Name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchSiteDetails = async () => {
    try {
      const { data } = await axiosInstance.get("SiteDetail/GetAll");
      setIsSiteDetailsData(data);
    } catch (error) {
      console.error("Error fetching site details:", error);
    }
  };
  const fetchSalePersons = async () => {
    try {
      const { data } = await axiosInstance.get("User/GetAllUser");
      setSalesPersons(data);
    } catch (error) {
      console.error("Error fetching Sale Person", error);
    }
  };
  const fetchQuotationDetails = async () => {
    try {
      const { data } = await axiosInstance.get(
        `WindowQuotation/GetWindowQuotationsWithFiles/${quotationNo}`
      );
      if (data.quotations?.length > 0) {
        const quotation = data.quotations[0];

        setQuotationDetails({
          quotationNo: quotation.quotation_No || "",
          quotationDate: quotation.quotation_Date?.split("T")[0] || "",
          totalSqFt: quotation.total_Sqft || "",
          siteId: quotation.site_Id || "",
          remark: quotation.remark || "",
          salePersonId: quotation.sale_Person_Id?.toString() || "",
        });

        setDisplayNames({
          ownerName: quotation?.owner_Name || "-",
          architectName: quotation?.architect_Name || "-",
          fabricatorName: quotation?.fabricator_Name || "-",
        });

        setFiles(
          (data.fileDetails || []).map((f) => ({
            ...f,
            is_Active: f.is_Active === true,
          }))
        );

        if (quotation.site_Id) {
          await fetchDealDetails(quotation.site_Id);
        }
      }
    } catch (error) {
      console.error("Error fetching quotation details:", error);
    }
  };
  const fetchDealDetails = async (siteId) => {
    try {
      const { data } = await axiosInstance.get(
        `SiteDetail/GetArchitectFabricatorOwnerBySite/${siteId}`
      );
      if (data) {
        setSiteDetails(data);
        setDisplayNames((prev) => ({
          ...prev,
          ownerName: data.owner_Name || "-",
          architectName: data.architect_Name || "-",
          fabricatorName: data.fabricator_Name || "-",
        }));
      }
    } catch (error) {
      console.error("Error fetching deal details:", error);
    }
  };

  const updateDisplayNames = () => {
    if (!siteDetails) return;

    setDisplayNames({
      ownerName: siteDetails.owner_Name || "-",
      architectName: siteDetails.architect_Name || "-",
      fabricatorName: siteDetails.fabricator_Name || "-",
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setQuotationDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (activeDetailsData && activeDetailsData.quotations?.length > 0) {
      const quotation = activeDetailsData.quotations[0];

      setQuotationDetails((prev) => ({
        ...prev,
        quotationNo: quotation.quotation_No || "",
        quotationDate: quotation.quotation_Date
          ? quotation.quotation_Date.split("T")[0]
          : "",
        totalSqFt: quotation.total_Sqft || "",
        siteId: quotation.site_Id || "",
        remark: quotation.remark || "",
        salePersonId: quotation.sale_Person_Id?.toString() || "",
        stageId: quotation.stage_Id,
        finalAmount: quotation.final_Amount || "",
        finalProfileColor: quotation.final_Profile_Color || "",
        glassColorType: quotation.glass_Color_Type || "",
        workCompleteDate: quotation.work_Complete_Date?.split("T")[0] || "",
        reason: quotation.reason || "",
      }));

      if (activeDetailsData.fileDetails?.length) {
        setFiles(activeDetailsData.fileDetails);
      }
      setDisplayNames({
        ownerName: quotation.owner_Name || "-",
        architectName: quotation.architect_Name || "-",
        fabricatorName: quotation.fabricator_Name || "-",
      });
      setIsEditing(true);
    }
  }, [activeDetailsData]);

  const handleSiteChange = async (selectedOption) => {
    if (!selectedOption) {
      setQuotationDetails((prev) => ({
        ...prev,
        siteId: "",
      }));
      return;
    }

    const siteId = selectedOption.value;
    setQuotationDetails((prev) => ({
      ...prev,
      siteId,
    }));

    if (siteId === "add-new") {
      // setIsModelOpen(true);
      navigate("/transaction/site-details");
    } else {
      await fetchDealDetails(siteId);
    }
  };

  useEffect(() => {
    if (quotationDetails.siteId && isSiteDetailsData.length > 0) {
      const selectedSite = isSiteDetailsData.find(
        (site) => site.site_Id.toString() === quotationDetails.siteId.toString()
      );
      if (selectedSite) {
        setQuotationDetails((prev) => ({
          ...prev,
          siteId: selectedSite.site_Id.toString(),
        }));
      }
    }
  }, [isSiteDetailsData, quotationDetails.siteId]);

  const handleViewSiteDetails = () => {
    if (!siteDetails) return;

    navigate("/transaction/site-details", {
      state: { siteData: siteDetails, isReadOnly: true },
    });
  };
  useEffect(() => {
    if (!quotationNo && !isEditing) {
      setQuotationDetails((prev) => ({
        ...prev,
        salePersonId: prev.salePersonId || userId,
      }));
    }
  }, [quotationNo, isEditing]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (!validateForm()) {
      return;
    }
    try {
      const payload = {
        Quotation_Date: quotationDetails.quotationDate
          ? new Date(quotationDetails.quotationDate).toISOString()
          : null,
        Site_Id: quotationDetails.siteId
          ? parseInt(quotationDetails.siteId)
          : null,
        Total_Sqft: parseFloat(quotationDetails.totalSqFt) || 0,
        Remark: quotationDetails.remark || "",
        Sale_Person_Id: quotationDetails.salePersonId
          ? parseInt(quotationDetails.salePersonId)
          : null,
        Quote_Amount: quotationDetails.quote_Amount || "0.00",
        Updated_By: userId,
        Created_By: userId,
        ...(Number(quotationDetails.stageId) === 2 && {
          Final_Amount: quotationDetails.finalAmount,
          Final_Profile_Color: quotationDetails.finalProfileColor,
          Glass_Color_Type: quotationDetails.glassColorType,
          Work_Complete_Date: quotationDetails.workCompleteDate
            ? new Date(quotationDetails.workCompleteDate).toISOString()
            : null,
        }),
        ...(Number(quotationDetails.stageId) === 3 && {
          Reason: quotationDetails.reason,
        }),
      };

      if (quotationDetails.quotationNo) {
        payload.Quotation_No = quotationDetails.quotationNo;
      }

      const response = await axiosInstance.post(
        "WindowQuotation/SaveUpdateQuotation",
        payload
      );

      if (response.status === 200) {
        if (files.length > 0) {
          await handleSaveFiles({ quotationNo: response.data.quotationNo });
        }
        notify(
          isEditing
            ? "Window Quotation updated successfully!"
            : "Window Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/window-quotation"), 1000);
      }
    } catch (error) {
      notify("Error saving quotation:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveFiles = async ({ quotationNo }) => {
    try {
      for (const file of files) {
        const isNewFile = !!file.file && !file.seq_No;
        const attachDate = new Date(file.attach_Date)
          .toISOString()
          .split("T")[0];
        if (isNewFile && Number(quotationNo) === 0) {
          const formData = new FormData();
          formData.append("Quotation_No", quotationNo);
          formData.append("Seq_No", file.Seq_No || 0);
          formData.append("File_Name", file.file);
          formData.append("Attach_Date", attachDate);
          formData.append("Quote_Amount", file.quote_Amount || 0);
          formData.append("Is_Active", file.is_Active ? 1 : 0);
          formData.append("Created_By", userId);

          await axiosInstance.post("WindowQuotation/SaveFileDetail", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
        if (isNewFile && Number(quotationNo) > 0) {
          const formData = new FormData();
          formData.append("Seq_No", file.Seq_No || 0);
          formData.append("Quotation_No", quotationNo);
          formData.append("File_Name", file.file);
          formData.append("Attach_Date", attachDate);
          formData.append("Quote_Amount", file.quote_Amount || 0);
          formData.append("Is_Active", file.is_Active ? 1 : 0);
          formData.append("Created_By", userId);

          await axiosInstance.post("WindowQuotation/SaveFileDetail", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }

        if (!isNewFile && file.seq_No) {
          const payload = {
            Seq_No: file.seq_No,
            Quotation_No: quotationNo,
            File_Name_Path: file.file_Name_Path || file.file_Name,
            Attach_Date: attachDate,
            Quote_Amount: Number(file.quote_Amount || 0),
            Is_Active: file.is_Active ? 1 : 0,
            Modified_By: 5,
          };

          await axiosInstance.post("WindowQuotation/UpdateFileDetail", payload);
        }
      }
    } catch (error) {
      console.error("🚨 Error updating/saving files:", error);
      notify("Error while saving or updating files", "error");
    }
  };
  const options = [
    ...isSiteDetailsData.map((site) => ({
      value: site.site_Id?.toString() || "",
      label: site.site_Name || "Unnamed Site",
    })),
    { value: "add-new", label: "+ Add New Site Details" },
  ];
  const salePersonOptions = salesPersons.map((per) => ({
    value: String(per.sale_Person_Id),
    label: per.Sale_Person_Name,
  }));

  const premiumSelectStyles = (error = false) => ({
    control: (base, state) => ({
      ...base,
      borderRadius: "0.5rem",
      padding: "0px 4px",
      border: error ? "1.5px solid #fda4af" : state.isFocused ? "1.5px solid #405189" : "1.5px solid #e2e8f0",
      backgroundColor: error ? "#fff1f2" : "white",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(64, 81, 137, 0.05)" : "none",
      transition: "all 0.2s ease",
      minHeight: "32px",
      height: "32px",
      "&:hover": { borderColor: state.isFocused ? "#405189" : "#cbd5e1" },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 6px",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "1rem",
      overflow: "hidden",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
      border: "1px solid #f1f5f9",
      padding: "4px",
      zIndex: 9999999,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    option: (base, state) => ({
      ...base,
      borderRadius: "0.5rem",
      backgroundColor: state.isSelected ? "#405189" : state.isFocused ? "#f8fafc" : "transparent",
      color: state.isSelected ? "white" : "#475569",
      padding: "6px 10px",
      fontWeight: state.isSelected ? "700" : "500",
      fontSize: "0.75rem",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      fontSize: "0.75rem",
      fontWeight: "600",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1e293b",
      fontWeight: "700",
      fontSize: "0.75rem",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#405189" : "#cbd5e1",
      padding: "2px",
    }),
  });

  return (
    <>
      <Toast />
      <div>
        {isLoading ? (
          <div className="flex items-center justify-center min-h-[60vh]">
            <Loader />
          </div>
        ) : (
          <div>
            {/* Header section */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
              <div className="flex flex-col">
                <h1 className="text-xl font-black text-slate-800 tracking-tight uppercase">Window Details</h1>
                <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider mt-0.5">Refine and manage your window quotation parameters</p>
              </div>
              <button
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 text-[11px] font-black uppercase tracking-widest rounded-xl border border-slate-200 shadow-sm transition-all flex items-center gap-2 active:scale-95"
                onClick={() => navigate(`/quotes/window-quotation`)}
              >
                <span className="text-lg">←</span> Back to List
              </button>
            </div>

            <form className="space-y-4" onSubmit={handleSubmit}>
              {/* Main attributes card */}
              <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/40 to-primary"></div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                  {/* Left Column: Quotation No & Site Details */}
                  <div className="space-y-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800">
                        Quotation No
                      </label>
                      <input
                        id="quotationNo"
                        name="quotationNo"
                        type="text"
                        value={quotationDetails.quotationNo}
                        onChange={handleChange}
                        disabled
                        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-400 font-bold cursor-not-allowed text-xs focus:ring-1 focus:ring-primary/20 outline-none transition-all"
                      />
                    </div>

                    <div className="flex flex-col space-y-2">
                      <div className="flex items-center gap-2">
                        <label className="text-xs font-bold text-gray-800 flex items-center gap-1.5">
                          Site Name
                          <button
                            type="button"
                            onClick={handleViewSiteDetails}
                            className="text-slate-900 hover:text-primary transition-colors mt-0.5"
                            title="View Site Details"
                          >
                            <IoEyeSharp className="w-3.5 h-3.5" />
                          </button>
                          <FaStarOfLife className="text-red-500 w-1.5 h-1.5" />
                        </label>
                      </div>
                      <Select
                        options={options}
                        value={
                          quotationDetails.siteId
                            ? options.find((option) => option.value === quotationDetails.siteId) || null
                            : null
                        }
                        isClearable
                        isSearchable
                        onChange={handleSiteChange}
                        menuPortalTarget={document.body}
                        styles={premiumSelectStyles(errors.siteId)}
                        placeholder="Select..."
                      />
                      {errors.siteId && (
                        <p className="text-red-500 text-[10px] font-black mt-1 uppercase italic tracking-tighter">{errors.siteId}</p>
                      )}

                      {/* Site Details List */}
                      <div className="mt-4 space-y-1.5 px-1">
                        <div className="flex items-center py-0.5 gap-4">
                          <span className="text-[11px] font-bold text-gray-700 w-24">Owner :</span>
                          <span className="text-[11px] font-medium text-slate-500 uppercase tracking-tight">{displayNames.ownerName}</span>
                        </div>
                        <div className="flex items-center py-0.5 gap-4">
                          <span className="text-[11px] font-bold text-gray-700 w-24">Architect :</span>
                          <span className="text-[11px] font-medium text-slate-500 uppercase tracking-tight">{displayNames.architectName}</span>
                        </div>
                        <div className="flex items-center py-0.5 gap-4">
                          <span className="text-[11px] font-bold text-gray-700 w-24">Fabricator :</span>
                          <span className="text-[11px] font-medium text-slate-500 uppercase tracking-tight">{displayNames.fabricatorName}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Date, SqFt & Sale Person */}
                  <div className="space-y-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800">
                        Quotation Date
                      </label>
                      <input
                        id="quotationDate"
                        name="quotationDate"
                        type="date"
                        value={quotationDetails.quotationDate}
                        onChange={handleChange}
                        onFocus={(e) => e.target.showPicker()}
                        className={`w-full rounded-lg border px-3 py-2 outline-none transition-all duration-300 font-bold text-xs ${errors.quotationDate
                          ? "border-red-300 bg-red-50/20"
                          : "border-slate-200 bg-white hover:border-primary/30 focus:border-primary ring-primary/5 focus:ring-4"
                          }`}
                      />
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800 flex items-center gap-1.5">
                        Total SqFt
                        <FaStarOfLife className="text-red-500 w-1.5 h-1.5" />
                      </label>
                      <input
                        id="totalSqFt"
                        name="totalSqFt"
                        type="text"
                        value={quotationDetails.totalSqFt}
                        onChange={handleChange}
                        placeholder=""
                        className={`w-full rounded-lg border px-3 py-2 outline-none transition-all duration-300 font-bold text-xs ${errors.totalSqFt
                          ? "border-red-300 bg-red-50/20"
                          : "border-slate-200 bg-white hover:border-primary/30 focus:border-primary ring-primary/5 focus:ring-4"
                          }`}
                      />
                      {errors.totalSqFt && (
                        <p className="text-red-500 text-[10px] font-black mt-1 uppercase italic tracking-tighter">{errors.totalSqFt}</p>
                      )}
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800">
                        Sale Person
                      </label>
                      {userId === "1" ? (
                        <Select
                          options={salePersonOptions}
                          value={salePersonOptions.find((option) => String(option.value) === String(quotationDetails.salePersonId)) || null}
                          isClearable
                          onChange={(option) => setQuotationDetails((prev) => ({ ...prev, salePersonId: option ? option.value : "" }))}
                          menuPortalTarget={document.body}
                          styles={premiumSelectStyles()}
                          placeholder="Select Sale Person"
                        />
                      ) : (
                        <input
                          type="text"
                          value={salePersonOptions.find((person) => String(person.value) === String(quotationDetails.salePersonId))?.label || "-"}
                          disabled
                          className="w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 py-2 text-slate-500 font-bold text-xs cursor-not-allowed"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Files section */}
              <div className="pt-2">
                <QuotesFiles
                  files={files}
                  setFiles={setFiles}
                  isEditing={isEditing}
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Remarks Section */}
                <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden flex flex-col">
                  <div className="bg-slate-50/50 px-5 py-2.5 border-b border-slate-100">
                    <h2 className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Additional Notes</h2>
                  </div>
                  <div className="p-4 flex-grow">
                    <textarea
                      id="remark"
                      rows="3"
                      name="remark"
                      value={quotationDetails.remark}
                      onChange={handleChange}
                      className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-300 font-bold text-xs leading-relaxed"
                      placeholder="Enter any additional documentation or notes..."
                    ></textarea>
                  </div>
                </div>

                {/* Status/Stage specific fields */}
                <div
                  className={` ${Number(quotationDetails.quotationNo) === 0 || Number(quotationDetails.stageId) === 1
                    ? "hidden"
                    : "bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden flex flex-col"
                    }`}
                >
                  <div className="bg-slate-50/50 px-5 py-2.5 border-b border-slate-100">
                    <h2 className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Stage Parameters</h2>
                  </div>
                  <div className="p-4 space-y-3">
                    {shouldShowCloseWonFields(Number(quotationDetails.stageId)) && (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="flex flex-col space-y-1">
                          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Final Amount</label>
                          <input
                            type="text"
                            name="finalAmount"
                            value={quotationDetails.finalAmount || ""}
                            onChange={handleChange}
                            disabled={!isCloseWonEditable(Number(quotationDetails.stageId))}
                            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 font-bold text-primary text-xs focus:border-primary outline-none transition-all"
                          />
                        </div>
                        <div className="flex flex-col space-y-1">
                          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Profile Color</label>
                          <input
                            type="text"
                            name="finalProfileColor"
                            value={quotationDetails.finalProfileColor || ""}
                            onChange={handleChange}
                            disabled={!isCloseWonEditable(Number(quotationDetails.stageId))}
                            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 outline-none focus:border-primary transition-all"
                          />
                        </div>
                        <div className="flex flex-col space-y-1">
                          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Glass Color</label>
                          <input
                            type="text"
                            name="glassColorType"
                            value={quotationDetails.glassColorType || ""}
                            onChange={handleChange}
                            disabled={!isCloseWonEditable(Number(quotationDetails.stageId))}
                            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 outline-none focus:border-primary transition-all"
                          />
                        </div>
                        <div className="flex flex-col space-y-1">
                          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Completion Date</label>
                          <input
                            type="date"
                            name="workCompleteDate"
                            value={quotationDetails.workCompleteDate || ""}
                            onChange={handleChange}
                            disabled={!isCloseWonEditable(Number(quotationDetails.stageId))}
                            className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 outline-none focus:border-primary transition-all"
                          />
                        </div>
                      </div>
                    )}
                    {shouldShowCloseLostReason(Number(quotationDetails.stageId)) && (
                      <div className="flex flex-col space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Rejection Reason</label>
                        <textarea
                          name="reason"
                          value={quotationDetails.reason || ""}
                          onChange={handleChange}
                          rows="2"
                          className="w-full rounded-xl border border-red-100 bg-red-50/10 px-3 py-2 outline-none focus:border-red-400 focus:ring-4 focus:ring-red-400/5 transition-all text-xs font-bold leading-relaxed"
                          placeholder="Rejection reason..."
                        ></textarea>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col md:flex-row items-center justify-end gap-3 pt-4 pb-10">
                <button
                  type="button"
                  className="w-full md:w-auto px-6 py-2.5 bg-white text-slate-600 text-[10px] font-black uppercase tracking-widest rounded-xl border border-slate-200 hover:bg-slate-50 transition-all active:scale-[0.98]"
                  onClick={() => navigate(-1)}
                >
                  Discard Changes
                </button>
                {(isEditing ? permission.isUpdate : permission.isInsert) && (
                  <button
                    className="w-full md:w-auto px-8 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded-xl shadow-md shadow-primary/20 hover:shadow-lg hover:translate-x-1 transition-all active:scale-[0.98] flex items-center justify-center gap-3"
                    type="submit"
                  >
                    <span>{isEditing ? "Update Quotation" : "Initialize Quotation"}</span>
                    <span className="text-base">→</span>
                  </button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default ActiveDetails;
